import { atom } from 'recoil';

const sendExternal = localStorage.getItem('sendExternal');
const defaultValue = sendExternal == 'true' ? true : false;
console.log(`defaultValue: ${defaultValue}`);

export const sendExternalState = atom({
  key: 'sendExternalState',
  default: defaultValue,
});
